import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-20 px-4 bg-white text-center" data-id="element-81">
      <div className="max-w-2xl mx-auto" data-id="element-82">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-83">
          No sigas improvisando tu práctica profesional
        </h2>
        <p className="text-lg text-gray-600 mb-8" data-id="element-84">
          Únete a las psicólogas que ya trabajan con más orden, claridad y menor
          desgaste.
        </p>

        <div className="bg-purple-50 p-8 rounded-3xl border border-purple-100 inline-block w-full max-w-md" data-id="element-85">
          <h3 className="font-black text-xl text-purple-900 mb-2" data-id="element-86">
            MEGA PACK TERAPÉUTICO PARA PSICÓLOGAS™
          </h3>
          <p className="text-sm font-bold text-purple-600 uppercase tracking-wide mb-6" data-id="element-87">
            👉 Descárgalo ahora con 60% de descuento
          </p>

          <CTAButton text="SÍ, QUIERO LA OFERTA AHORA" subtext="Acceso inmediato por $13 USD" fullWidth={true} data-id="element-88" />
        </div>
      </div>
    </section>;
}